/**
 * @generated SignedSource<<42f0fd812991a0a959b7aab4513b8512>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VaultRing = "BETA" | "GA" | "INTERNAL" | "%future added value";
export type vaultToggleMutationsSetVaultRingMutation$variables = {
  ring: VaultRing;
  vaultId: any;
};
export type vaultToggleMutationsSetVaultRingMutation$data = {
  readonly setVaultRing: {
    readonly ring: VaultRing;
    readonly vaultId: any;
  };
};
export type vaultToggleMutationsSetVaultRingMutation = {
  response: vaultToggleMutationsSetVaultRingMutation$data;
  variables: vaultToggleMutationsSetVaultRingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ring"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ring",
        "variableName": "ring"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "concreteType": "VaultRingState",
    "kind": "LinkedField",
    "name": "setVaultRing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ring",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "vaultToggleMutationsSetVaultRingMutation",
    "selections": (v2/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "vaultToggleMutationsSetVaultRingMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c36a6eac5cdecddd62ed3dc3a4ff506b",
    "id": null,
    "metadata": {},
    "name": "vaultToggleMutationsSetVaultRingMutation",
    "operationKind": "mutation",
    "text": "mutation vaultToggleMutationsSetVaultRingMutation(\n  $vaultId: UUID!\n  $ring: VaultRing!\n) {\n  setVaultRing(vaultId: $vaultId, ring: $ring) {\n    vaultId\n    ring\n  }\n}\n"
  }
};
})();

(node as any).hash = "46d7b213a08ca86f252968276f38819b";

export default node;
